import { Backdrop, Modal, Slide } from '@material-ui/core';
import React, { ReactNode } from 'react';
import '../../../../stylesheets/components/device_map_modal.scss';
import useStatusBarEffect from '../../../hooks/modal/useStatusBarEffect';
import { DeviceMapModalHeader } from './DeviceMapModalHeader';

interface DeviceMapModalProps {
  open: boolean;
  onClose?: () => void;
  children: ReactNode;
}

const DeviceMapModalV2: React.FC<DeviceMapModalProps> = ({ open, onClose, children }) => {

  // Change status bar color on IOS when modal is shown.
  useStatusBarEffect(open);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className="deviceMapModal"
      open={open}
      /* onClose={onClose} */
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        className: 'deviceMapModalBackdrop',
      }}
    >
      <Slide direction="up" in={open} mountOnEnter unmountOnExit>
        <div className="deviceMapModalWindow">
          <DeviceMapModalHeader onClose={onClose} />
          <div className="deviceMapModalWindow_content">
            {children}
          </div>
        </div>
      </Slide>
    </Modal>
  );
};

export default DeviceMapModalV2;